import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  backLink: {
    display: 'flex',
    alignItems: 'center',
    color: 'text.secondary',
    cursor: 'pointer',
    mb: '4px'
  } satisfies SxProps<Theme>,
  title: {
    mb: '16px'
  } satisfies SxProps<Theme>,
  panel: {
    backgroundColor: 'var(--grey-100)',
    borderRadius: '12px',
    p: { xs: '20px', md: '32px' }
  } satisfies SxProps<Theme>,
  yearSelect: {
    backgroundColor: 'var(--white)'
  } satisfies SxProps<Theme>,
  search: {
    backgroundColor: 'var(--white)',
    minWidth: { xs: '100%', md: 360 }
  } satisfies SxProps<Theme>,
  activityCard: {
    borderRadius: '12px',
    p: '16px 20px'
  } satisfies SxProps<Theme>,
  viewToggle: {
    backgroundColor: 'primary.main',
    borderRadius: '6px',
    p: '2px',
    '& .MuiToggleButton-root': {
      border: 0,
      color: 'var(--white)',
      textTransform: 'none',
      px: '16px',
      '&.Mui-selected': {
        backgroundColor: 'var(--white)',
        color: 'primary.main',
        borderRadius: '4px',
        '&:hover': { backgroundColor: 'var(--white)' }
      }
    }
  } satisfies SxProps<Theme>
}
